/**
 * Native smooth scroll that becomes an instant jump when the user prefers reduced motion.
 */
export function prefersReducedMotion(): boolean {
	if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
		return false;
	}
	return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export function scrollToSmoothRespectingMotion(
	options: ScrollToOptions,
	target: Pick<Window, "scrollTo"> = typeof window !== "undefined"
		? window
		: { scrollTo: () => undefined },
): void {
	const behavior =
		prefersReducedMotion() || options.behavior === "auto"
			? "auto"
			: (options.behavior ?? "smooth");
	target.scrollTo({ ...options, behavior });
}
